module.exports = __webpack_public_path__ + "img/type_draw@2x.a15ee6c9.png";